import { togglePendingStoreActions } from '@/utils/decorators';
import { API } from '@/config';

import {
  SET_TOKEN_VALIDATION_STATE,
  FILL_AUTH_SERVICE_POINT_DATA,
  TOGGLE_WAITING_FOR_AUTH_SERVICE_POINT_DATA,
  SET_STATE_FOR_WAITING_FOR_AUTH_SERVICE_POINT_DATA,
  SET_AFTER_AUTHORIZATION_URL,
  SET_FORM_TYPE,
} from './mutations-types';

export default {

  async getAuthServicePointSettingsByToken({ commit, dispatch }, token = '') {
    try {
      const { params, type, platform_url, gateway, lang, brand, support_email } = (await API.get(
        `/authServicesPoints/getAuthServicePointSettingsByToken?token=${token}`)).data.data;
      commit(FILL_AUTH_SERVICE_POINT_DATA, { params, type, platform_url, gateway });
      commit(SET_TOKEN_VALIDATION_STATE, { isValid: true });
      commit(TOGGLE_WAITING_FOR_AUTH_SERVICE_POINT_DATA);

      dispatch('global/setPropertiesOfThePlatform', { lang, brand, support_email }, { root: true });
    } catch (err) {
      commit(SET_TOKEN_VALIDATION_STATE, { isValid: false });
      commit(TOGGLE_WAITING_FOR_AUTH_SERVICE_POINT_DATA);
    }

    return token;
  },

  @togglePendingStoreActions()
  async changeFormState({ commit }, state) {
    try {
      commit(SET_FORM_TYPE, state);
    } catch (err) {
      console.log(err);
    }
  },

  @togglePendingStoreActions()
  async loginToASP({ commit }, { params, token, gateway }) {
    try {
      const { url } = (await API.post(
        '/authServicesPoints/loginToASP', { params, token, gateway },
      )).data.data;
      commit(SET_AFTER_AUTHORIZATION_URL, { url });
    } catch (err) {
      console.log(err);
    }
  },

  @togglePendingStoreActions()
  async registerToASP({ commit }, { params, token, gateway }) {
    try {
      await API.post('/authServicesPoints/registerToASP', { params, token, gateway });
      commit(SET_FORM_TYPE, 'confirm');
    } catch (err) {
      console.log(err);
    }
  },

  @togglePendingStoreActions()
  async changePasswordToASP({ commit }, { params, token, gateway }) {
    try {
      params.platform = window.location.origin;
      await API.post('/authServicesPoints/changePasswordToASP', { params, token, gateway });
      commit(SET_FORM_TYPE, 'email_change_password');
    } catch (err) {
      console.log(err);
    }
  },

  @togglePendingStoreActions()
  async confirmChangePasswordToASP({ commit }, { params, token, gateway }) {
    try {
      await API.post('/authServicesPoints/confirmChangePasswordToASP', { params, token, gateway });
      commit(SET_FORM_TYPE, 'confirm_new_change_password');
    } catch (err) {
      console.log(err);
    }
  },

  @togglePendingStoreActions()
  async sendVerificationCode({ commit }, { params, token, gateway }) {
    try {
      await API.post('/authServicesPoints/sendVerificationCode', { params, token, gateway });
      commit(SET_FORM_TYPE, 'verification');
    } catch (err) {
      console.log(err);
    }
  },

  @togglePendingStoreActions()
  async resendVerificationCode(_, { params, token, gateway }) {
    try {
      await API.post('/authServicesPoints/sendVerificationCode', { params, token, gateway });
      // commit(SET_FORM_TYPE, 'verification');
    } catch (err) {
      console.log(err);
    }
  },

  setStateForWaitingForAuthServicePointData({ commit }, newState) {
    commit(SET_STATE_FOR_WAITING_FOR_AUTH_SERVICE_POINT_DATA, newState);
  },

};



// WEBPACK FOOTER //
// ./src/store/modules/authServicesPoints/actions.js